module.exports = __webpack_public_path__ + "media/link.9a719ad7.wav";